export default {
	label: 'Status',
	implemented: 'Implemented',
	conditionallyImplemented: 'Conditionally implemented',
	partiallyImplemented: 'Partially implemented',
	notImplemented: 'Not implemented',
	needsAttention: 'Needs attention',
	willNotImplement: 'Will not implement',
	willNotApply: 'Will not apply',
	renewedMeasure: 'Renewed measure',
	hover: {
		conditionallyImplemented:
			'This measure is conditionally implemented - one or more rules have "Will not implement"/"Will not apply" status.',
	},
}
